import { render } from "./HeroListShowDetailRuneRecList.vue?vue&type=template&id=5c1dc116"
import script from "./HeroListShowDetailRuneRecList.vue?vue&type=script&lang=js"
export * from "./HeroListShowDetailRuneRecList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gaomingliang/github/vue3_wzheros/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__